import { AlarmIcon } from 'components/icons'
import { Tooltip } from 'components/ui'
import { useApp } from 'context/app-context'
import { useCurrentUser } from 'context/current-user-context'
import classNames from 'helpers/class-names'
import useSubscriptionListener from 'hooks/use-subscription-listener'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const TrialTicker = () => {
  const { navigationCollapsed } = useApp()
  const router = useRouter()
  const { daysUntilTrialEnds, isAdmin } = useCurrentUser()
  const [mouseOver, setMouseOver] = useState(false)
  const [shake, setShake] = useState(true)
  useSubscriptionListener()
  let timeout

  useEffect(() => {
    timeout = setTimeout(() => {
      setShake(false)
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  const handleClick = () => {
    if (!isAdmin) {
      return
    }
    router.push('/billing')
  }

  return (
    <Tooltip
      tip={
        navigationCollapsed ? `${daysUntilTrialEnds} days left in trial` : null
      }
      placement="right">
      <div className="mt-4 w-full px-4">
        <button
          onMouseEnter={() => setMouseOver(true)}
          onMouseLeave={() => setMouseOver(false)}
          onClick={handleClick}
          disabled={!isAdmin}
          className={classNames(
            'group flex w-full rounded-lg bg-primary outline-none transition-all duration-300  focus-visible:ring-2 focus-visible:ring-info/75',
            { 'hover:cursor-not-allowed': !isAdmin },
            { 'hover:bg-primary-darken': isAdmin },
          )}>
          <div className="p-1">
            <AlarmIcon
              className={classNames('mx-auto size-8 text-white/85', {
                'animate-shake': mouseOver || shake,
              })}
            />
          </div>
          {!navigationCollapsed && (
            <div className="flex w-full flex-1 flex-col pl-1.5 pt-0.5 text-left text-xs text-white/80">
              {!!daysUntilTrialEnds && (
                <span className="pt-px">
                  {daysUntilTrialEnds} days left in trial
                </span>
              )}
              {!daysUntilTrialEnds && (
                <span className="pt-px">Last day of trial</span>
              )}
              <span className="font-bold uppercase text-white">
                Upgrade Now
              </span>
            </div>
          )}
        </button>
      </div>
    </Tooltip>
  )
}

export default TrialTicker
